import { AppConfiguration } from "../app-configuration";
export class AuthConfiguration {
// SECURED RUOLI URLs
public static authLogin = AppConfiguration.SECURED + '/ruoli/auth/login';
public static getRuoliUtente = AppConfiguration.SECURED + '/ruoli/getRuoliUtente/';
public static setRuoloAttivo = AppConfiguration.SECURED + '/ruoli/setRuoloAttivo/';
public static assistenzaRuoli = AppConfiguration.SECURED + '/ruoli/email/assistenza/';
public static isUtenteAssistenza = AppConfiguration.SECURED + '/api/utenza/isUtenteAssistenza';
}